import styled from "styled-components";
import { RenderImages } from "../../../designComponents/Table/renderMethods";
import Typography from "../../../designComponents/Typography";
import ReviewButtons from "./review/ReviewButtons";
import { LabelText, SectionTitle, StyledCard, ValueText } from "./styles";
import { PropertyFeaturesProps } from "./types";

// Interfaces

// Styled components
const GroupContainer = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  border-bottom: 1px solid #eee;
  background-color: #fefcf0;
  border-radius: 8px;

  & > div + div {
    margin-top: 30px;
  }
`;

const RefImageRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-top: 16px;
  flex-wrap: wrap;
  background-color: rgba(150, 150, 150, 0.1);
  padding: 10px;
  border-radius: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const InfoColumn = styled.div`
  flex: 1;
  min-width: 200px;

  & > div + div {
    margin-top: 8px;
  }
`;
const InfoRowStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  min-width: 200px;

  & > div + div {
    margin-top: 8px;
  }
`;

const ImageColumn = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const fieldKey = "RefRoom";

function RefImages({
  isAccepted,
  propertyDetail,
  setOpenReviewModal,
  hasPreviousReview,
  hasRecentReview,
  onViewReviews,
}: PropertyFeaturesProps) {
  const refImageGroups = propertyDetail?.property?.refImageGroups;

  return (
    <StyledCard style={{ margin: 0 }}>
      <SectionTitle>Reference Images</SectionTitle>
      {isAccepted !== null && (
        <Typography
          style={{
            alignItems: "center",
            gap: "6px",
            color: isAccepted ? "green" : "red",
            fontWeight: 600,
            fontSize: "1rem",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          {isAccepted ? "Accepted" : "Rejected"}
        </Typography>
      )}
      {refImageGroups?.map((group) => (
        <GroupContainer key={group?._id}>
          <div>
            <InfoRowStyled>
              <LabelText>Reference Group Title</LabelText>
              <ValueText>{group?.title}</ValueText>
            </InfoRowStyled>

            <InfoRowStyled>
              <LabelText>Status</LabelText>
              <ValueText>{group?.status}</ValueText>
            </InfoRowStyled>
            <InfoRowStyled>
              <LabelText>Published At</LabelText>
              <ValueText>
                {group?.publishedAt
                  ? new Date(group?.publishedAt).toLocaleString()
                  : "Not published yet."}
              </ValueText>
            </InfoRowStyled>
          </div>

          <div>
            {group?.refImages?.map((ref, index) => (
              <RefImageRow
                style={{
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
                key={ref?._id}
              >
                <InfoColumn>
                  <Typography fontWeight="bold" size={"title"}>
                    {index + 1}.
                  </Typography>
                  <div>
                    <Typography
                      size={"title"}
                      fontFamily="poppins"
                      fontWeight="semibold"
                    >
                      {ref?.title}
                    </Typography>
                  </div>

                  <div>
                    <LabelText>Description:</LabelText>
                    <ValueText>{ref?.description}</ValueText>
                  </div>
                  <div>
                    <LabelText>Visible:</LabelText>
                    <ValueText>{ref?.isVisible ? "Yes" : "No"}</ValueText>
                  </div>
                </InfoColumn>

                <ImageColumn>
                  <RenderImages
                    images={ref?.images}
                    resize={true}
                    displayImage
                  ></RenderImages>
                </ImageColumn>
              </RefImageRow>
            ))}
          </div>
        </GroupContainer>
      ))}

      <ReviewButtons
        fieldKey={fieldKey}
        hasPreviousReview={hasPreviousReview}
        hasRecentReview={hasRecentReview}
        isAccepted={!!isAccepted}
        onViewReviews={onViewReviews}
        setOpenReviewModal={setOpenReviewModal}
        underReview={propertyDetail?.property.status === "UNDER_REVIEW"}
      />
    </StyledCard>
  );
}

export default RefImages;
